export default __webpack_public_path__ + "static/media/new-logo.0852124c.svg";